module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "tag-boxes"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "absolute",
      "bottom": "0"
    }
  }, _vm._l((_vm.tagArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tag-body mx-1",
      class: {
        'tag-active': _vm.recordMode === index
      },
      on: {
        "click": function($event) {
          return _vm.doTag(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('img', {
    staticClass: "back-icon pointer my-4",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("../../../../assets/image/icon/close_lesson.png")
    },
    on: {
      "click": _vm.previousPage
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "recordInfo",
    staticStyle: {
      "weight": "100%"
    }
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$route.params.mode) + " " + _vm._s(_vm.$t('learning_record')) + ":\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "p-0 m-0"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('study_time')) + ": " + _vm._s(_vm.recordInfo.spendTime) + "\n    ")]), _vm._v(" "), (_vm.$route.params.mode === 'App') ? _c('div', [_c('p', {
    staticClass: "p-0 m-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('coins')) + ": " + _vm._s(_vm.recordInfo.goldNum) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "p-0 m-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('AR_unlocked')) + ": " + _vm._s(_vm.recordInfo.unlockNum) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "p-0 m-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('missions_completed')) + ": " + _vm._s(_vm.recordInfo.missionFinishedNum) + "\n      ")])]) : _vm._e()]), _vm._v(" "), _c('h5', {
    staticClass: "py-5"
  }, [_vm._v(_vm._s(_vm.$t('click_below_detailed')))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.countrys), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "px-2 countrys-box"
    }, [_c('div', {
      staticClass: "unit-box",
      on: {
        "click": function($event) {
          return _vm.goUnit(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.pic
      }
    }), _vm._v(" "), _c('h5', [(_vm.locale === 'tw') ? _c('span', [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(item.englishName) + "\n          ")])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b637aee0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/ar/record/RecordCountry.vue
// module id = 807
// module chunks = 3